import React from 'react';
import './Nosotros.css';
import '../App.css';

export default function Nosotros({ go }) {
  return (
    <main className="page-home">

      {/* MISIÓN Y VISIÓN */}
      <section id="mision-vision" className="mission-vision">
        <div className="container">
          <h2 className="section-title">Nuestra Misión y Visión</h2>

          <div className="mv-grid">
            <div className="mv-item">
              <div className="mv-image-wrap">
                <img src="/img/Nosotros/vision.jpg" alt="Misión de transporte" className="truck-photo" />
                <span className="mv-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                    <path d="M2 17l10 5 10-5" />
                    <path d="M2 12l10 5 10-5" />
                  </svg>
                  Nuestra razón de ser
                </span>
              </div>
              <article className="mv-card">
                <h3>Misión</h3>
                <p>Ofrecer soluciones de transporte confiables y puntuales que impulsen el crecimiento de nuestros clientes, asegurando la integridad de la carga y optimizando procesos logísticos.</p>
              </article>
            </div>

            <div className="mv-item mv-item-reverse">
              <div className="mv-image-wrap">
                <img src="/img/Nosotros/mision.jpg" alt="Visión de transporte" className="truck-photo" />
                <span className="mv-badge">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  Hacia dónde vamos
                </span>
              </div>
              <article className="mv-card">
                <h3>Visión</h3>
                <p>Ser la empresa líder en transporte de mercancías a nivel nacional, reconocida por innovación, sostenibilidad y excelencia en el servicio al cliente.</p>
              </article>
            </div>
          </div>
        </div>
      </section>

      {/* ================= SEPARADOR ================= */}
      <div className="separador-wrap">
        <div className="separador-track">
          <div className="separador-group">
            <h1 className="separadorh1">Transporte Urbano y Nacional de Carga en Bogotá</h1>
            <button className="separadorbutton" onClick={() => go('contacto')}>
              Cotizar ya mismo</button>
          </div>
          <div className="separador-group" aria-hidden="true">
            <h1 className="separadorh1"> Transporte Urbano y Nacional de Carga en Bogotá</h1>
            <button className="separadorbutton">Cotizar ya mismo</button>
          </div>
        </div>
      </div>

      {/* ================= TRANSPORTE URBANO ================= */}
      <section className="urban-transport">
        <div className="urban-grid">

          {/* INFO */}
          <div className="urban-info">
            <span className="eyebrow">Cobertura local</span>
            <h2>Nos especializamos en transporte urbano</h2>
            <p>
              Ofrecemos soluciones de transporte de carga dentro de la ciudad,
              optimizando tiempos, rutas y costos para garantizar entregas seguras
              y eficientes.
            </p>

            <ul>
              <li>Entregas rápidas y seguras</li>
              <li>Cobertura urbana completa</li>
              <li>Seguimiento en tiempo real</li>
              <li>Atención personalizada</li>
            </ul>
          </div>

          {/* IMAGEN / MAPA */}
          <div className="urban-visual">
            <img
              src="/img/Nosotros/338grande.jpeg"
              alt="Transporte urbano"
            />
          </div>

        </div>
      </section>

      {/* VALORES Y SEGURIDAD */}
      <section className="security-block">
        <div className="container">
          <span className="eyebrow">Compromiso</span>
          <h2 className="section-title">Nuestro Compromiso</h2>
          <div className="security-grid">
            <div className="security-item">
              <div className="security-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>
              <h4>Protocolos de Seguridad</h4>
              <p>Protocolos rigurosos de cargue y descargue para proteger tu mercancía</p>
            </div>

            <div className="security-item">
              <div className="security-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" />
                  <path d="M12 12l4-4" />
                  <circle cx="12" cy="12" r="1" />
                </svg>
              </div>
              <h4>Seguimiento en Tiempo Real</h4>
              <p>Monitoreo constante durante todo el trayecto de tu envío</p>
            </div>

            <div className="security-item">
              <div className="security-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
                </svg>
              </div>
              <h4>Conductores Capacitados</h4>
              <p>Equipo profesional con entrenamiento continuo en seguridad vial</p>
            </div>

            <div className="security-item">
              <div className="security-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 7v5l3 3" />
                </svg>
              </div>
              <h4>Puntualidad Garantizada</h4>
              <p>Cumplimiento de tiempos acordados en cada entrega</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}